EVHI High Pressure <br>
<br>
Status: {{ cCPXDEV_EVHI?.status }}<br/>
Digital Input: {{ cCPXDEV_EVHI?.digitalinput }}<br/>
Frequency: {{ cCPXDEV_EVHI?.frequency | number: "1.2-2" }}<br/>
Counter:   {{ cCPXDEV_EVHI?.pulses  | number: "1.0-0" }}<br/>
